import { render, staticRenderFns } from "./secondary.vue?vue&type=template&id=e18e97c4&scoped=true&"
import script from "./secondary.vue?vue&type=script&lang=js&"
export * from "./secondary.vue?vue&type=script&lang=js&"
import style0 from "./secondary.vue?vue&type=style&index=0&id=e18e97c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18e97c4",
  null
  
)

export default component.exports